import { siteInfo } from '@/mocks/homepage';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center pt-[64px] md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20flowing%20gradients%20in%20deep%20crimson%20red%2C%20burnt%20orange%2C%20and%20rich%20amber%20tones%2C%20soft%20atmospheric%20glow%20effect%2C%20elegant%20motion%20blur%20texture%2C%20luxurious%20and%20dramatic%20mood%2C%20dark%20edges%20fading%20to%20warm%20center%2C%20cinematic%20lighting%20style%2C%20no%20text%20or%20people%2C%20pure%20abstract%20art&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-500/30 backdrop-blur-sm rounded-full border border-accent-300/30 mb-4 md:mb-5">
              <i className="ri-fire-line text-accent-300 text-sm"></i>
              <span className="text-xs md:text-sm font-medium text-accent-100 whitespace-nowrap">劲爆尺度内容每日精选</span>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-3 md:mb-4">
              {siteInfo.name}
              <span className="block text-accent-400 mt-1">擦边视频与擦边图片福利合集</span>
            </h1>

            <p className="text-base md:text-lg text-white leading-relaxed max-w-2xl mx-auto lg:mx-0 opacity-90">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-5 md:mt-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-white/15 backdrop-blur-sm rounded-lg">
                    <i className={`${stat.icon} text-white text-sm md:text-base`}></i>
                  </span>
                  <div className="text-left">
                    <div className="text-lg md:text-xl font-bold text-white leading-none">{stat.value}</div>
                    <div className="text-xs text-white/70">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6 md:mt-7">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-2 px-6 py-3 md:px-7 md:py-3.5 bg-primary-500 text-white font-bold rounded-lg hover:bg-primary-600 transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                <span>查看热度榜单</span>
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-2 px-6 py-3 md:px-7 md:py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-lg hover:bg-white/25 transition-all duration-200 border border-white/20 text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-image-line"></i>
                <span>浏览精选推荐</span>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20art%20with%20flowing%20organic%20shapes%20in%20warm%20crimson%20red%2C%20deep%20amber%20gold%2C%20and%20rich%20terracotta%20tones%2C%20luxurious%20fluid%20texture%20design%20with%20soft%20glowing%20highlights%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20people%2C%20dramatic%20artistic%20composition%20with%20dark%20corners%20and%20bright%20center%20flow&width=800&height=600&seq=hero-visual&orientation=landscape"
                alt="爆料专区 - 擦边视频与擦边图片福利合集主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}